<template>
  <footer class="footers">
    <div class="cow foottxt">
      <p>电话：400-926-3100</p>
      <p>邮箱：jiangsubinggu@jsbingo.cn</p>
      <p>地址：江苏省无锡市滨湖区锦溪路100号</p>
      <p style="opacity:0.3">Copyright © 2008-2020 江苏冰谷数字科技有限公司</p>
      <p style="opacity:0.1">公共安全体验馆设计厂家,展示区,施工方案,价格,哪家好</p>
      <img src="../../assets/images/c0.png" />
      <!-- <p>版权所有 苏ICP备18041182号-1</p> -->
    </div>

    <div class="footer fwc">
      <div class="footerBox">
        <div class="footerTop fwc">
          <div class="ftLeft fhs">
            <img :src="$fileUrl+companys.logo" />
          </div>
          <div class="ftMid">
            <div class="cow dv1">
              <a @click="go(0)">公司简介</a> |
              <a @click="go(1)">产品技术</a> |
              <a @click="go(2)">案例展示</a> |
              <a @click="go(3)">新闻资讯</a> |
              <a @click="go(4)">关于我们</a>
            </div>
            <div class="cow dv2">江苏冰谷数字科技有限公司（江苏省无锡市滨湖区锦溪路100号）</div>
            <div class="cow dv3">服务热线：400-926-3100 邮 箱：jiangsubinggu@jsbingo.cn</div>
            <div class="cow dv4">
              版权所有 Copyright © 2020 江苏冰谷数字科技有限公司
              <a
                target="_blank"
                href="https://beian.miit.gov.cn/"
              >苏 ICP备18041182号-1</a>
            </div>
            <p style="opacity:.3;color: white;    font-size: 12px;
    line-height: 1.3;">公共安全体验馆设计厂家,展示区,施工方案,价格,哪家好</p>

          </div>
          <div class="ftRight fws">
            <div class="ftt fhs">
              <img src="../../assets/images/c0.png" />
              <span>官方公众号</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      imgPath: "../../assets/images/c1.png",
      pages: [
        { path: "home", name: "首页", en: "HOME" },
        { path: "product", name: "技术产品", en: "PRODUCT" },
        { path: "case", name: "案例分析", en: "CASE" },
        { path: "news", name: "新闻资讯", en: "NEWS" },
        { path: "aboutus", name: "关于我们", en: "CONTACT" }
      ]
    };
  },
  props: {
    //选中
    tabActiveIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    loadDom() {
      //console.log(this.companys);
    },
    go(index) {
      this.$router.replace({
        path: this.pages[index].path
      });
    }
  },
  watch: {},
  components: {},
  created() {},
  mounted() {
    this.loadDom();
  },
  computed: {
    ...mapGetters(["companys"])
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/reset/reset.css";
@import "../../assets/css/reset/common.less";
@import "../../assets/css/fonts/iconfont.css";
@import "../../assets/css/home.css";
@import "../../assets/css/hover.css";
.footers {
  width: 100%;
  height: auto;
  float: left;
  position: relative;
  z-index: 200;
  overflow: hidden;
}
.footer {
  width: 100%;
  height: 185px;
  background: #222222;
  position: relative;
  z-index: 2;
  float: left;
  box-sizing: border-box;
  overflow: hidden;
  .footerBox {
    width: @pcPageWidth;
    height: 100%;
    position: absolute;
    left: 50%;
    margin-left: -@pcPageWidth / 2;
  }
  .footerTop {
    width: 100%;
    margin-top: 0px;
    height: 185px;
  }
  .ftLeft {
    width: auto;
    height: auto;
    box-sizing: border-box;
    margin-top: -30px;
    img {
      width: 98px;
      height: 75px;
      object-fit: contain;
      display: block;
    }
  }
  .ftMid {
    width: 524px;
    height: auto;
    float: left;
    margin: 0 70px;
    .dv1 {
      font-size: 14px;
      color: #fff;
      margin-bottom: 16px;
      letter-spacing: 1px;
      a {
        cursor: pointer;
      }
    }
    .dv2,
    .dv3,
    .dv4 {
      font-size: 12px;
      color: #b4b4b4;
      margin-bottom: 6px;
      letter-spacing: 1px;
      a {
        color: #b4b4b4;
        text-decoration: underline !important;
      }
    }
  }
  .ftRight {
    width: auto;
    height: auto;
    box-sizing: border-box;
    .ftt {
      margin-right: 30px;
      span {
        font-size: 14px;
        color: #999;
      }
      img {
        width: 86px;
        height: 86px;
        margin-bottom: 6px;
      }
    }
  }

  .ftend {
    width: 238px;
    height: 100%;
    box-sizing: border-box;
    padding-top: 46px;
    align-items: flex-start !important;
    p {
      color: #fff;
      font-size: 12px;
      line-height: 1.5;
      letter-spacing: 1px;
    }
    span {
      color: #9e9c99;
      font-size: 12px;
      margin-top: 12px;
      line-height: 1.5;
      letter-spacing: 1px;
    }
  }
}
.footer2 {
  width: 100%;
  height: 42px;
  background: #222222;
  position: relative;
  z-index: 2;
  float: left;
  box-sizing: border-box;
  background: #313131;
  .footBot {
    width: @pcPageWidth;
    height: 100%;
    bottom: 0px;
    position: absolute;
    left: 50%;
    margin-left: -@pcPageWidth / 2;
    box-sizing: border-box;
    padding: 0 9% 0 11%;
    p {
      color: #fff;
      font-size: 12px;
      letter-spacing: 1px;
    }
  }
}
.foottxt {
  display: none;
}

@media screen and (min-width: 760px) and (max-width: 1024px) {
  .footer .ftMid {
    width: 350px;
    margin: 0 50px;
  }
  .dv2,
  .dv3,
  .dv4 {
    letter-spacing: 0px;
  }
  .dv1 {
    display: none;
  }
}

@media screen and (max-width: 759px) {
  .footer,
  .footer2 {
    display: none;
  }
  .foottxt {
    display: block !important;
    padding: 20px 0;
    background: #333;
  }
  .foottxt img {
    width: 52px;
    height: 52px;
    position: absolute;
    right: 5%;
    top: 16px;
  }
  .foottxt p {
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 1.3;
    margin-bottom: 4px;
    opacity: 0.8;
  }
  .foottxt p:nth-child(1),
  .foottxt p:nth-child(2),
  .foottxt p:nth-child(3) {
    text-align: left;
    padding-left: 5%;
    box-sizing: border-box;
  }
  .foottxt p:nth-child(4) {
    margin-top: 16px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?5414eada